<div class="gate" *ngIf="visible">
  <!-- live region 은 텍스트 전용 노드로 분리한다. 체크박스·버튼까지 감싸면 선택을 바꿀 때마다
       서브트리 전체가 다시 낭독된다. -->
  <p class="gate-sr-only" role="status">{{ announcement }}</p>

  <ng-container [ngSwitch]="phase">
    <p *ngSwitchCase="'loading'" class="gate-body">일정을 확인하고 있습니다…</p>

    <!-- 조회 실패. 일정이 있는지 모르는 상태라 "등록하러 가라"고 단정하지 않는다. -->
    <ng-container *ngSwitchCase="'error'">
      <p class="gate-title">일정을 확인하지 못했습니다</p>
      <p class="gate-body">예약 가능한 일정이 1건 이상 있어야 검수를 요청할 수 있습니다. 일정 관리에서 확인해주세요.</p>
      <a class="gate-link" [routerLink]="['/host/schedule']" [queryParams]="{ productId: productId }">
        일정 관리로 가기
      </a>
    </ng-container>

    <ng-container *ngSwitchCase="'empty'">
      <p class="gate-title">예약받을 일정을 먼저 등록해주세요</p>
      <p class="gate-body">예약 가능한 일정이 1건 이상 있어야 검수를 요청할 수 있습니다.</p>
      <a class="gate-link" [routerLink]="['/host/schedule/add', productId]">일정 등록하러 가기</a>
    </ng-container>

    <!-- 켜거나 열 것이 없는데 예약도 못 받는 상태 — 남은 회차가 모두 예약 마감 시간을 지났다. -->
    <ng-container *ngSwitchCase="'stuck'">
      <p class="gate-title">예약을 받을 수 있는 회차가 없습니다</p>
      <p class="gate-body">
        남은 회차가 모두 예약 마감 시간을 지났습니다. 회차를 추가하면 검수를 요청할 수 있습니다.
      </p>
      <a class="gate-link" [routerLink]="['/host/schedule/add', productId]">회차 추가하러 가기</a>
    </ng-container>

    <ng-container *ngSwitchCase="'flow'">
      <p class="gate-step">{{ totalSteps }}단계 중 {{ stepNumber }}단계</p>

      <ng-container *ngIf="step === 'pick'">
        <fieldset class="gate-fieldset">
          <legend class="gate-title">판매할 일정을 골라주세요</legend>
          <p class="gate-body">아래 일정은 판매 상태가 꺼져 있어 예약을 받지 못합니다.</p>

          <label class="gate-choice" *ngFor="let item of groups">
            <input type="checkbox" [(ngModel)]="item.selected" [disabled]="submitting" />
            <span class="gate-choice-text">
              <strong>{{ item.value.name }}</strong>
              <span class="gate-choice-meta">
                {{ formatDay(item.value.from) }}<ng-container *ngIf="item.value.to">
                  ~ {{ formatDay(item.value.to) }}</ng-container
                >
                · 회차 {{ item.value.futureTicketCount }}개
              </span>
            </span>
          </label>
        </fieldset>

        <p class="gate-body" *ngIf="hasPastSchedule">지나간 날짜의 일정은 목록에 없습니다.</p>
        <p class="gate-hint" id="gate-pick-hint" *ngIf="selectedGroups.length === 0">하나 이상 골라주세요.</p>
        <p class="gate-error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>

        <button
          type="button"
          class="gate-button"
          [disabled]="submitting || selectedGroups.length === 0"
          [attr.aria-busy]="submitting"
          [attr.aria-describedby]="selectedGroups.length === 0 ? 'gate-pick-hint' : null"
          (click)="activateSelected()"
        >
          {{ submitting ? '바꾸는 중…' : '판매중으로 바꾸기' }}
        </button>
      </ng-container>

      <ng-container *ngIf="step === 'reopen'">
        <fieldset class="gate-fieldset">
          <legend class="gate-title">예약을 다시 열 회차를 골라주세요</legend>
          <p class="gate-body">직접 마감하거나 휴무로 지정한 회차는 판매 상태를 켜도 예약을 받지 못합니다.</p>

          <label class="gate-choice" *ngFor="let item of tickets">
            <input type="checkbox" [(ngModel)]="item.selected" [disabled]="submitting" />
            <span class="gate-choice-text">
              <strong>{{ formatDayTime(item.value.date) }}</strong>
              <span class="gate-choice-meta">직접 마감함</span>
            </span>
          </label>

          <!-- 휴무는 날짜 단위로만 풀린다. 회차 하나를 고르게 하면 고르지 않은 같은 날 회차까지
               열려 화면이 사실과 다른 말을 한다. -->
          <label class="gate-choice" *ngFor="let item of holidays">
            <input type="checkbox" [(ngModel)]="item.selected" [disabled]="submitting" />
            <span class="gate-choice-text">
              <strong>{{ formatKstDay(item.value.kstDate) }} 휴무</strong>
              <span class="gate-choice-meta">
                이 날짜의 회차 {{ item.value.ticketCount }}개가 함께 열립니다 — 같은 날짜의 다른 일정도
                포함됩니다
              </span>
            </span>
          </label>
        </fieldset>

        <p class="gate-hint" id="gate-reopen-hint" *ngIf="!hasReopenSelection">하나 이상 골라주세요.</p>
        <p class="gate-error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>

        <button
          type="button"
          class="gate-button"
          [disabled]="submitting || !hasReopenSelection"
          [attr.aria-busy]="submitting"
          [attr.aria-describedby]="!hasReopenSelection ? 'gate-reopen-hint' : null"
          (click)="reopenSelected()"
        >
          {{ submitting ? '여는 중…' : '예약 다시 열기' }}
        </button>
      </ng-container>

      <ng-container *ngIf="step === 'done'">
        <!-- 서버 판정을 다시 받아 확인한다. 일정에서 뺀 회차는 이 화면이 알 수 없어(그 컬럼이
             클라이언트로 오지 않는다) 켜도 바뀌지 않는 그룹이 목록에 오를 수 있다. -->
        <ng-container *ngIf="hasReservableTicket; else stillBlocked">
          <p class="gate-title">일정을 고쳤습니다</p>
          <p class="gate-body">이제 아래 「검수 요청」 버튼을 눌러주세요.</p>
        </ng-container>
        <ng-template #stillBlocked>
          <p class="gate-title">아직 예약을 받지 못합니다</p>
          <p class="gate-body">
            고른 일정은 바꿨지만 예약 가능한 회차가 생기지 않았습니다. 일정 관리에서 남은 회차를 확인해주세요.
          </p>
          <a class="gate-link" [routerLink]="['/host/schedule']" [queryParams]="{ productId: productId }">
            일정 관리로 가기
          </a>
        </ng-template>
        <p class="gate-error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
